// src/pages/AccountDeletionRequest.jsx

import React from 'react';
import { AlertTriangle, ArrowLeft, ExternalLink, Trash2 } from 'lucide-react';

const AccountDeletionRequest = () => {
  const handleRequestDeletion = () => {
    // Redirect to your Typeform
    window.location.href = "https://nissiinfotech.typeform.com/to/XnahXm";
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Back Button */}
        <button
          onClick={() => window.history.back()}
          className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span>Back to Profile</span>
        </button>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          {/* Red Warning Header */}
          <div className="bg-red-600 px-8 py-12 text-white text-center">
            <div className="flex justify-center mb-4">
              <div className="w-20 h-20 bg-red-700/30 rounded-2xl flex items-center justify-center">
                <AlertTriangle size={48} />
              </div>
            </div>
            <h1 className="text-4xl font-bold mb-3">Delete Account</h1>
            <p className="text-red-100 text-lg">
              This action is permanent and cannot be undone
            </p>
          </div>

          <div className="p-8 md:p-10">
            <div className="space-y-6">
              <div className="bg-red-50 border border-red-100 rounded-2xl p-6">
                <h3 className="font-semibold text-red-800 mb-4 flex items-center gap-2">
                  <AlertTriangle size={22} />
                  Important Consequences
                </h3>
                <ul className="space-y-3 text-red-700">
                  <li className="flex gap-3">
                    <span className="font-medium">•</span>
                    All your personal data will be permanently deleted
                  </li>
                  <li className="flex gap-3">
                    <span className="font-medium">•</span>
                    You will lose access to all attendance records and history
                  </li>
                  <li className="flex gap-3">
                    <span className="font-medium">•</span>
                    This action cannot be reversed
                  </li>
                  <li className="flex gap-3">
                    <span className="font-medium">•</span>
                    Processing may take up to 7 business days
                  </li>
                </ul>
              </div>

              <div className="text-center py-4">
                <p className="text-gray-600">
                  To proceed with account deletion, please fill out our secure deletion form.
                </p>
              </div>

              {/* Request Button */}
              <button
                onClick={handleRequestDeletion}
                className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 
                         text-white font-semibold text-lg py-5 rounded-2xl 
                         transition-all duration-200 flex items-center justify-center gap-3
                         shadow-lg shadow-red-500/30 hover:shadow-xl"
              >
                <Trash2 size={24} />
                Request Account Deletion
                <ExternalLink size={20} />
              </button>

              <p className="text-center text-sm text-gray-500 mt-6">
                You will be redirected to a secure form to complete your request.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Note */}
        <p className="text-center text-xs text-gray-500 mt-10">
          Need assistance? Contact support at support@nissiinfotech.com
        </p>
      </div>
    </div>
  );
};

export default AccountDeletionRequest;